import {Injectable} from "@angular/core";
import {Http, Response, Headers, RequestOptions, ResponseContentType} from "@angular/http";
import {Observable} from "rxjs";
import {Router} from "@angular/router";
import {AuthService} from "../auth/auth.service";
import {environment} from "../../../environments/environment";

declare let window: any;
window.push = {
  _key: '__hey_pushToken',
  httpService: null,

  init(token) {
    const item = {
      token: token,
      isUpdate: false, 
    }

    if(this.httpService) {
      this.httpService.setPushToken(item.token)
      item.isUpdate = true
    }

    localStorage.setItem(this._key, JSON.stringify(item))
  },
  removeToken() {
    localStorage.removeItem(this._key)
  },
  update() {
    const item = JSON.parse(localStorage.getItem(this._key));

    if(this.httpService && item && !item.isUpdate) {
      this.httpService.setPushToken(item.token)
      item.isUpdate = true
    }

    localStorage.setItem(this._key, JSON.stringify(item))
  }
}

@Injectable()
export class HttpService {
  authorization: string = 'Authorization';
  tokenPrefix: string = 'Bearer ';

  startRefreshToken: boolean = false;
  basicAuthetication = 'aGV5Z3JvdW5kLXdlYjpmb28='; //btoa('heyground-web:foo');

  constructor(private authService: AuthService,
              private http: Http,
              private router: Router) {
    window.push.httpService = this;
  }

  getHeader(addHeader={}, isDownload=false): Observable<RequestOptions> {
    return this.authService.getAccessToken().flatMap(accessToken => {
      let headers: Headers = new Headers({'Content-Type': 'application/json', ...addHeader});
      let options: RequestOptions = new RequestOptions({headers: headers, withCredentials: false});
      if (isDownload) {
        options.responseType = ResponseContentType.Blob;
      }
      if (accessToken) {
        options.headers.set(this.authorization, this.tokenPrefix + accessToken);
      }
      return Observable.of(options);
    });
  }

  get(url: string): Observable<Response> {
    return this.getHeader().flatMap(header =>
      this.http.get(environment.apiServer + url, header).catch(error => HttpService.handleError(error, this)).shareReplay()
    );
  }

  download(url: string): Observable<Response> {
    return this.getHeader({'Accept': 'application/pdf'}, true).flatMap(header => 
      this.http.get(environment.apiServer + url, header).catch(error => HttpService.handleError(error, this))
    );
  }

  post(url: string, body: any): Observable<Response> {
    return this.getHeader().flatMap(header =>
      this.http.post(environment.apiServer + url, body, header).catch(error => HttpService.handleError(error, this)).shareReplay()
    );
  }

  put(url: string, body: any): Observable<Response> {
    return this.getHeader().flatMap(header =>
      this.http.put(environment.apiServer + url, body, header).catch(error => HttpService.handleError(error, this)).shareReplay()
    );
  }

  delete(url: string): Observable<Response> {
    return this.getHeader().flatMap(header =>
      this.http.delete(environment.apiServer + url, header).catch(error => HttpService.handleError(error, this)).shareReplay()
    );
  }

  login(username: string, password: string): Observable<Response> {
    let loginHeader = new Headers({
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic ' + this.basicAuthetication
    });
    let body = `grant_type=password&username=${username}&password=${encodeURIComponent(password)}`;
    return this.http.post(environment.apiServer + '/oauth/token', body, {headers: loginHeader}).map(res => res.json());
  }

  logout() {
    this.authService.removeToken();
    this.startRefreshToken = false;
  }

  saveToken(token: any) {
    this.authService.saveToken(token);
  }

  static trySetPushToken: boolean = false;
  setPushToken(token: any) {
    if(token && this.authService.getToken()) {
      HttpService.trySetPushToken = true
      this.post('/api/members/device', token).subscribe();
    }
  }

  static handleError(error: any, httpService: HttpService): Observable<Response> {
    if (HttpService.trySetPushToken) {
      HttpService.trySetPushToken = false;
      window.push.removeToken();
    }
    
    if (error.status == 401 || error.status == 0) {
      httpService.authService.removeToken();
      httpService.router.navigateByUrl('/login');
    } else if(error.status == 404) {
      httpService.router.navigateByUrl('/404');
      window.history.replaceState({},'','/#/404');
    } else if(error.status >= 500) {
      let errorBody = JSON.parse(error._body);

      if(errorBody && errorBody.exception.indexOf('MemberExpiredException') !== -1) {
        httpService.authService.removeToken();
        httpService.router.navigateByUrl('/login');
      } 
      else if(errorBody && errorBody.message.indexOf('member') !== -1){
        httpService.authService.removeToken();
        httpService.router.navigateByUrl('/login');
      }
      else if(error.status ==  502) {
        httpService.router.navigateByUrl('/502');
      }
      else {
        httpService.router.navigateByUrl('/500');
      }
    }
    
    throw error
  }
}


// WEBPACK FOOTER //
// ./src/app/service/http/http.service.ts